"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceType = exports.NormSource = exports.EntryStatus = exports.EntryType = exports.UserRole = void 0;
exports.UserRole = {
    ADMIN: "ADMIN",
    DIRECTOR: "DIRECTOR",
};
exports.EntryType = {
    NORMED_WORK: "NORMED_WORK",
    NEUTRAL_ACTIVITY: "NEUTRAL_ACTIVITY",
    UNNORMED_WORK: "UNNORMED_WORK",
};
exports.EntryStatus = {
    DRAFT: "draft",
    CONFIRMED: "confirmed",
    LOCKED: "locked",
};
exports.NormSource = {
    MANUAL: "MANUAL",
    EXCEL_IMPORT: "EXCEL_IMPORT",
};
exports.SourceType = {
    MANUAL: "MANUAL",
    EXCEL_IMPORT: "EXCEL_IMPORT",
    AI_OCR_SUGGESTED: "AI_OCR_SUGGESTED",
};
//# sourceMappingURL=enums.js.map